const Badge = ({ className, count }) => {
  return <div className={className}>{count}</div>;
};

export default Badge;
